'use client'
import { TypedDocumentNode } from '@graphql-typed-document-node/core'
import { QueryClient } from '@tanstack/react-query'
import { GraphQLClient } from 'graphql-request'
// import { redirect } from "next/navigation";

const shouldDebug = () => {
  // Check NEXT_PUBLIC_ENV (used in docker) or NEXT_PUBLIC_VERCEL_ENV (used in Vercel)
  const env = process.env.NEXT_PUBLIC_ENV || process.env.NEXT_PUBLIC_VERCEL_ENV
  const nodeEnv = process.env.NODE_ENV
  
  return env === 'dev' || env === 'staging' || env === 'development' || env === 'preview' || nodeEnv === 'development'
}

type APIAuth0Error = {
  request: {
    query: string
    variables?: Record<string, unknown>
  }
  response: {
    description: string
    error: string
    status: number
    headers: Map<string, string>
  }
}

const isAPIAuth0Error = (err: unknown): err is APIAuth0Error => {
  return (err as APIAuth0Error).response?.error !== 'undefined'
}

const getBaseURL = () => {
  if (typeof document !== 'undefined') {
    let origin = window.location.origin
    return `${origin}/api/graphql`
  }
  return ''
}

export const gqlClient = () =>
  new GraphQLClient(`${getBaseURL()}`, {
    responseMiddleware(response) {
      if (shouldDebug()) {
        console.log(`[DEBUG] GraphQLClient: responseMiddleware called at ${new Date().toISOString()}`)
      }
      if (!(response instanceof Error)) {
        if (shouldDebug()) {
          const isOk = response?.status >= 200 && response?.status < 300
          console.log(`[DEBUG] GraphQLClient: Response status: ${response?.status}, ok: ${isOk}`)
        }
        const isNotOk = response?.status >= 400
        if (isNotOk) {
          if (shouldDebug()) {
            console.error(`[DEBUG] GraphQLClient: Error response detected (status ${response?.status})`)
          }
          // Router.push('/auth/logout')
          if (typeof window !== 'undefined') {
            window.location.href = '/auth/logout'
            return response
          }
          // redirect('/auth/login')
        }
      } else {
        if (shouldDebug()) {
          console.error(`[DEBUG] GraphQLClient: Response is an error:`, response)
        }
      }
    },
  })

export const prefetchGQLQuery = <TResult, TVariables>(
  queryClient: QueryClient,
  document: TypedDocumentNode<TResult, TVariables>,
  ...[variables]: TVariables extends Record<string, never> ? [] : [TVariables]
): Promise<void> =>
  queryClient.prefetchQuery(
    [(document.definitions?.[0] as any).name.value, variables],
    async ({ queryKey }) => {
      return gqlClient().request(
        document,
        queryKey?.[1] ? queryKey[1] : undefined
      )
    }
  )
